
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#585858","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15 8A7 7 0 111 8a7 7 0 0114 0z"}}),_c('path',{attrs:{"d":"M7.789 9.952v-.964c0-.24.195-.436.436-.436.964 0 1.746-.782 1.746-1.746v-.121c0-1.03-.836-1.867-1.867-1.867H8.06a1.91 1.91 0 00-1.909 1.91v.318m1.637 4.306v.158"}})])])
          )
        }
      }
    